<div class="wrapper">
    <div class="main">
        <div class="section section-white">
            <div class="container">

                <div class="row">
                    <div class="col-md-4 col-lg-4 col-sm-4 ml-auto mr-auto text-center title">
                        <div style="width: 100%;" class="card-image">

                            <img style="width: 100%;" crossorigin="anonymous" class="img-responsive"
                                [src]="Data.media" />
                        </div>
                    </div>
                </div>

                <div class="row mt-n5">
                    <div class="col-md-8 ml-auto mr-auto text-center title">
                        <h2>{{Data.title}}</h2>
                        <h3 class="title-uppercase"><small>Written by {{Data.author}}</small></h3>
                        <h6 class="title-uppercase">Published: {{Data.created}}</h6>
                    </div>
                </div>
                <div class="row">

                    <div class="col-md-8 ml-auto mr-auto" [innerHTML]="Data.body | safeHtml">

                    </div>


                </div>

                <div class="row mt-5">
                    <div class="col-md-8 ml-auto mr-auto">
                        <h6 class="title-uppercase ">Keywords</h6>
                        <div class="text-center">
                            <div [innerHTML]="Data.keywords">

                            </div>


                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>